import { BlocksDivider } from 'blocks-nextjs/blocks-web-components/components/divider/divider';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatDivider = createComponent({ react: React, tagName: 'cat-divider', elementClass: BlocksDivider });
